import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { asyncAction } from "../util/redux.js";
import { not } from "../util/fn.js";
import { getCurrentLocale } from "../l10n/store.js";
import { areStationsLoaded } from "./store.js";
export var loadStations = function loadStations(contractTypes) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState, context) {
      var currentLocale, cacheKey;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            currentLocale = getCurrentLocale(getState());
            cacheKey = contractTypes.join(",");
            _context3.next = 4;
            return dispatch(asyncAction({
              ifPredicate: not(areStationsLoaded(cacheKey)),
              typePrefix: "STATIONS/STATIONS",
              loadPayload: function () {
                var _loadPayload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var stations;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return context.api.stations.getStations({
                          contractTypes: contractTypes
                        });
                      case 2:
                        stations = _context2.sent;
                        _context2.next = 5;
                        return Promise.all(stations.map(/*#__PURE__*/function () {
                          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(station) {
                            var stationId, bookingRulesParameters, _yield$Promise$all, _yield$Promise$all2, openingTimes, bookingRules;
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) switch (_context.prev = _context.next) {
                                case 0:
                                  stationId = station.id;
                                  bookingRulesParameters = contractTypes.length > 1 ? {
                                    stationId: stationId
                                  } : {
                                    stationId: stationId,
                                    contractType: contractTypes[0]
                                  };
                                  _context.next = 4;
                                  return Promise.all([context.api.stations.getStationOpeningTimes({
                                    stationId: stationId
                                  }), context.api.stations.getStationBookingRules(bookingRulesParameters)]);
                                case 4:
                                  _yield$Promise$all = _context.sent;
                                  _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                                  openingTimes = _yield$Promise$all2[0];
                                  bookingRules = _yield$Promise$all2[1];
                                  return _context.abrupt("return", _objectSpread(_objectSpread({}, station), {}, {
                                    openingTimes: openingTimes,
                                    bookingRules: bookingRules
                                  }));
                                case 9:
                                case "end":
                                  return _context.stop();
                              }
                            }, _callee);
                          }));
                          return function (_x4) {
                            return _ref2.apply(this, arguments);
                          };
                        }()));
                      case 5:
                        _context2.t0 = _context2.sent;
                        _context2.t1 = cacheKey;
                        _context2.t2 = currentLocale;
                        return _context2.abrupt("return", {
                          stations: _context2.t0,
                          cacheKey: _context2.t1,
                          locale: _context2.t2
                        });
                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                function loadPayload() {
                  return _loadPayload.apply(this, arguments);
                }
                return loadPayload;
              }()
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};